import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import Certificate from './Certificate'
import DatePicker from 'react-datepicker'
import { useState } from 'react'
import { useAuth } from '../../../../auth'
import DownloadPDFButton from '../table/columns/DownloadPDFButton'

const initialState = {
  date: '',
  facility: '',
}
const QualityList = () => {
  const [userSelectedData, setUserSelectedData] = useState<any>(initialState)
  const [searchResult, setSearchResult] = useState(false)
  const connectedData =
    new Date(userSelectedData?.date || new Date())?.toLocaleDateString('en-GB') || ''
  const { isFacilityManager, auth }: any = useAuth()

  const { responseData: facilityTypeList } = useFetchCommon({
    // api: 'users?page=0&size=10&type=PICKUP_POINT',
    api: 'users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE% 2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY',
    label: ['personalDetails', 'name'],
    isDropDown: true,
    isEnabled: !isFacilityManager,
  })
  const { responseData: supplierData } = useFetchCommon({
    api: `supplierReport/${userSelectedData.facility}?date=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })
  /* FOR THE API */
  const { responseData: analyticsMonth } = useFetchCommon({
    api: `admin/pickupPoints/analytics/${userSelectedData.facility}?date=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })
  const { responseData: inventory } = useFetchCommon({
    api: `admin/pickupPoints/${userSelectedData.facility}/inventory?date=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })
  const { responseData: analytics } = useFetchCommon({
    api: `analytics/${userSelectedData.facility}?date=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })

  const handleChange = (name, value) => {
    setSearchResult(false)
    setUserSelectedData({ ...userSelectedData, [name]: value })
  }

  return (
    <>

      <div className="card mb-3">
        <div className="card-body">
          <div className={`grid grid-cols-4 gap-3 my-2`}>
            <>
              <div className=''>
                <label className='form-label fs-6 fw-bold'>Select Material Hub</label>
                <select
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #dddddd',
                    color: '#000000', // Text color for selected option
                  }}
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  onChange={(e) => handleChange('facility', e.target.value)}
                  value={userSelectedData.facility || ''}
                >
                  {[
                    { value: '', label: 'Select one' },
                    ...(isFacilityManager
                      ? [{ value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName }]
                      : facilityTypeList),
                  ].map((eachOption, eachInd) => (
                    <option key={eachInd + 1 + ''} value={eachOption.value}>
                      {eachOption.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className='form-label fs-6 fw-bold'>Day</label>
                <br />
                <DatePicker
                  customInput={
                    <input
                      style={{
                        backgroundColor: '#ffffff',
                        border: '1px solid #dddddd',
                        color: '#000000',
                      }}
                    />
                  }
                  placeholderText={`Select date`}
                  className='form-control form-control-solid w-250px ps-14'
                  maxDate={new Date()}
                  selected={userSelectedData.date || null}
                  // onChange={(date) => handleChange('date', new Date(date))}
                  onChange={(date) => {
                    const utcDate = date
                    handleChange('date', utcDate.toISOString())
                  }}
                />
                {/* <input
              type='date'
              placeholder='Select Month'
              className='form-control form-control-solid'
              max={new Date().toISOString().split('T')[0]}
              value={userSelectedData.date ?
                (userSelectedData.date instanceof Date ?
                  userSelectedData.date.toISOString().split('T')[0] :
                  new Date(userSelectedData.date).toISOString().split('T')[0]) :
                ''}
              onChange={(e) => {
                const utcDate = new Date(e.target.value);
                handleChange('date', utcDate.toISOString());
              }}
              style={{ width: '250px', backgroundColor: '#f9f9f9' }}
            /> */}
                {' '}
              </div>
              <div
                className='flex'
                style={{
                  marginTop: '27px',
                }}
              >
                <button
                  type='button'
                  // style={{ backgroundColor: '#ED6E43'}}
                  onClick={() => setSearchResult(true)}
                  className='btn btn-primary fw-bold px-6'
                  data-kt-menu-dismiss='true'
                  data-kt-user-table-filter='filter'
                  disabled={!userSelectedData.date || !userSelectedData.facility}
                >
                  Apply
                </button>
                &nbsp;
                <DownloadPDFButton
                  windowPrint={true}
                  disable={!userSelectedData.facility && !userSelectedData?.date}
                  className='btn btn-primary fw-bold px-6'
                  url={'url'}
                />
                {/*  <button
              type='button'
              style={{backgroundColor: '#333333'}}
              // onClick={handleExport}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
              disabled
              // disabled={dataToRender && dataToRender.length === 0}
            >
              Download
            </button> */}
              </div>
            </>
          </div>
        </div>

      </div>




      {
        /* Object.keys(inventory).length > 0 && */ <Certificate
          inventory={inventory}
          graphData={analytics}
          supplierData={supplierData}
          analyticsMonth={analyticsMonth?.[0] || {}}
          month={connectedData || ''}
        />
      }
    </>
  )
}

const DailyReportWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { DailyReportWrapper }
